<div class="toolbar-container">
  <div class="input-group width-slider">
    <span class="input-group-addon">Width</span>
    <!-- ranges doen't like being styled, so style a wrapper -->
    <span class="form-control">
      <input type="range" min="1" max="50" [(ngModel)]="tool.brushWidth" />
    </span>
    <span class="input-group-addon number-label">{{ tool.brushWidth }}</span>
  </div>
  <span class="lock-mask input-group">
    <mat-slide-toggle
      [ngModel]="store('lockMask').$ | async"
      (ngModelChange)="toggleLockMask()"
      labelPosition="before"
    >
      Lock all</mat-slide-toggle
    ></span
  >
</div>
